<template lang="pug">
  .page__wr
    .actions
      .actions__wr
        .actions__title-wr.title-oblique-line-anima
          h1.actions__title.title-anima
            | {{h1}}
        .actions__content
          .actions__slider.js-actions-slider(v-if="items")
            .swiper-container(ref="swiperContainer")
              .swiper-wrapper(@click="popupLocal($event)")
                .swiper-slide(v-for="item in items", :key="item.id", :data-id="item.id")
                  .actions__slider-item.js-actions-slider-item
                    .actions__slider-item-layout
                    .actions__slider-item-img-wr
                      img.actions__slider-item-img(:src="item.img", :alt="item.title")
                    .actions__slider-item-info
                      .actions__slider-item-title
                        | {{item.title}}
                      .actions__slider-item-date
                        | {{item.date}}

            .swiper-pagination(v-if='countOfSlideInPage > 1')
            .swiper-button-prev
              SvgIcon(class='actions__slider-ico' name="arrow-left" width="12" height="26")
            .swiper-button-next
              SvgIcon(class='actions__slider-ico' name="arrow-left" width="12" height="26")

      .actions__bottom-nav
        .page__wr
          BottomNav(:links="links", :btn="btn")
        Samedia
</template>

<script>
import EventBus from '@/eventBus';
import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
import BottomNav from '@/components/common/bottomNav/bottomNav.vue';
import Samedia from '@/components/common/samedia/Samedia.vue';

// @ is an alias to /src

import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
import {PopupHelpersVue} from '@/mixins/PopupHelpersVue';
import {determineWindowSize} from '@/mixins/determineWindowSize.js';

export default {
  name: 'Actions',

  mixins: [AjaxHelpersVue, PopupHelpersVue, determineWindowSize],

  components: {
    BottomNav,
    SvgIcon,
    Samedia
  },

  data() {
    return {
      items: null,
      countOfSlideInPage: 3,
      links: {
        prev: {
          href: "/gosti",
          txt: "Гости"
        },
        next: {
          href: "/galereya",
          txt: "Галерея"
        }
      },
      btn: {
        title: "Забронировать",
        type: "booking"
      }
    }
  },

  created() {
    // Загрузка данных для страницы
    EventBus.$on('loadActionsPage', url => {
      this.request(url);
    });
  },

  mounted() {
    this.determineWindowSize();
  },

  methods: {
    request(url) {
      this.req('ActionsPage:getActionsPage', {url}, res => {
        if (this.checkProperty(res.content.items)) {
          this.items = res.content.items;
        }

        this.$nextTick(() => {
          this.initSlider();
        });

        EventBus.$emit('pageDone');
      }, 'actions');
    },

    initSlider() {
      let $slider = $('.js-actions-slider');
      let $sliderNextBtn = $slider.find('.swiper-button-next');
      let $sliderPrevBtn = $slider.find('.swiper-button-prev');
      let $sliderPagination = $slider.find('.swiper-pagination');
      let that = this;

      if ($slider.find('.swiper-slide-active').length) return;

      let slidesCount = $slider.find('.swiper-slide').length;

      let sliderParams = {
        init: false,
        //autoplay: {
        //  delay: 5000
        //},
        slidesPerView: this.countOfSlideInPage,
        centeredSlides: true,
        speed: 600,
        spaceBetween: 0,
        slideDuplicateClass: 'swiper-slide-duplicate',
        navigation: {
          nextEl: $sliderNextBtn,
          prevEl: $sliderPrevBtn
        },
        pagination: {
          el: $sliderPagination,
          type: 'bullets',
          clickable: true
        },
        loop: true, // в цикле не работают события вью из-за клонирования слайдов без событий
        simulateTouch: true,
        observer: true, // если слайдер изначально скрыт
        observeParents: true, // если слайдер изначально скрыт
        on: {
          init: function () {
            if ($slider.find('.swiper-slide').length > 3) {
              that.slideClasses();
            }
          },

          transitionStart: function () {
            if ($slider.find('.swiper-slide').length > 3) {
              that.slideClasses();
            }
          }
        }
      };

      if (slidesCount <= 2 || slidesCount <= 3 && this.countOfSlideInPage > 2) {
        $.extend(sliderParams, {
          loop: false,
          virtualTranslate: true,
          centeredSlides: false
        });

        $sliderNextBtn.hide();
        $sliderPrevBtn.hide();
        $sliderPagination.hide();

        $('.js-actions-slider').addClass('actions__slider--center');
      }

      if ($slider.length) {
        let swiper = new Swiper(this.$refs.swiperContainer, sliderParams);

        swiper.init();
      }
    },

    slideClasses() {
      $('.js-actions-slider').addClass('actions__slider--effect');

      let $slides = $('.js-actions-slider').find('.swiper-slide');
      let $activeSlide = $slides.filter('.swiper-slide-active');

      let $prevSlides = $activeSlide.prevAll();
      let $nextSlides = $activeSlide.nextAll();

      $slides.removeClass('actions__slide--effect');

      $nextSlides.addClass('actions__slide--effect');

      $prevSlides.addClass('actions__slide--effect');

    },

    popupLocal(e) {
      let $parent = $(e.target).parents('[data-id]');
      let id = $parent.attr('data-id') || '';

      this.popup('action', 'show', id);
    }
  }
}
</script>

<style>
.actions {
  height: 96%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
